import {useEffect, useRef, useState} from "react";
import {toaster} from "rsuite";
import type {SyncDeviceParameter_SyncDeviceParameterType} from "../../../api";
import {SharedApi} from "../../../services/Shared.api";
import NotificationFactory from "../../../shared/Notifications";
import UpdateButton from "../UpdateButton/UpdateButton";

type DeviceParameterSyncButtonProps = {
  deviceId: string | number;
  parameter: SyncDeviceParameter_SyncDeviceParameterType;
  onSynced?: () => void | Promise<void>;
};

const parameterLabels: Record<SyncDeviceParameter_SyncDeviceParameterType, string> = {
  FirmwareVersion: "версию прошивки",
  Place: "место установки"
};

const DeviceParameterSyncButton = ({
  deviceId,
  parameter,
  onSynced
}: DeviceParameterSyncButtonProps) => {
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);
  const parameterLabel = parameterLabels[parameter];

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleSync = async () => {
    if (loading) return;

    setLoading(true);
    let synced = false;

    try {
      await SharedApi.syncDeviceParameter(String(deviceId), parameter);
      synced = true;
      await onSynced?.();
      toaster.push(
        NotificationFactory.success(`Удалось обновить ${parameterLabel}`),
        {placement: "topEnd"}
      );
    } catch (error) {
      console.error(`Ошибка синхронизации параметра ${parameter}:`, error);
      toaster.push(
        NotificationFactory.error(
          synced
            ? `Параметр сохранён, но не удалось обновить данные`
            : `Не удалось обновить ${parameterLabel}`
        ),
        {placement: "topEnd"}
      );
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  };

  return (
    <UpdateButton
      loading={loading}
      onRefresh={handleSync}
      tooltip={`Обновить ${parameterLabel} с устройства`}
    />
  );
};

export default DeviceParameterSyncButton;
